var GeocodeMap = {
	$address: null,
	geocoder: null,
	map: null,

	/**
	 * Init.
	 */
	init: function () {
		jQuery( document ).ready( function () {
			if ( ! jQuery( '#flux-ty-map-canvas' ).length || ! google ) {
				return;
			}

			GeocodeMap.geocode();
		} );

	},

	/**
	 * Geocode.
	 */
	geocode: function () {
		GeocodeMap.geocoder = new google.maps.Geocoder();
		GeocodeMap.geocoder.geocode(
			{
				'address': jQuery('#flux-ty-map-canvas').data( 'address' )
			},
			GeocodeMap.setupMap
		);
	},

	/**
	 * Setup Map.
	 *
	 * @param {*} results 
	 * @param {*} status 
	 * @returns 
	 */
	 setupMap: function( results, status ) {
		if ( status !== google.maps.GeocoderStatus.OK ) {
			jQuery( '#flux-ty-map-canvas' ).hide();
		} 

		var options = {
			zoom: 12,
			center: results[ 0 ].geometry.location,
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			zoomControl: false,
			mapTypeControl: false,
			scaleControl: false,
			streetViewControl: false,
			rotateControl: false,
			fullscreenControl: false
		};

		GeocodeMap.map = new google.maps.Map( document.getElementById("flux-ty-map-canvas"), options );

		var marker = new google.maps.Marker({
			map: GeocodeMap.map,
			position: results[0].geometry.location,
			title: jQuery( '#flux-ty-map-canvas' ).data( 'address' ),
		});
	}
};

export default GeocodeMap;